module.exports = __webpack_public_path__ + "img/Stirling.ace96af0.png";